module.exports = __webpack_public_path__ + "static/media/2_of_spades.403ff5e1.png";